<template>
  <wd-tabbar
    :model-value="curTabbarRoute"
    placeholder
    bordered
    safe-area-inset-bottom
    fixed
    custom-class="!bg-box"
    @change="handleTabbarChange"
  >
    <template v-for="(item, index) in filteredTabbarList" :key="index">
      <wd-tabbar-item
        v-if="item.iconType === 'wot'"
        :name="item.pagePath"
        :title="item.text"
        :icon="item.icon"
      />
      <wd-tabbar-item
        v-else-if="item.iconType === 'local'"
        :name="item.pagePath"
        :title="item.text"
      >
        <template #icon>
          <image
            class="w-24px h-24px"
            :src="
              item.active ? resolveImgPath(item.selectedIconPath) : resolveImgPath(item.iconPath)
            "
          ></image>
        </template>
      </wd-tabbar-item>
      <wd-tabbar-item
        v-else-if="item.iconType === 'iconify'"
        :name="item.pagePath"
        :title="item.text"
      >
        <template #icon>
          <text
            class="text-xl mb-1"
            :class="item.active ? `${item.icon} icon-active` : `${item.icon} icon-inactive`"
          />
        </template>
      </wd-tabbar-item>
    </template>
  </wd-tabbar>
</template>

<script lang="ts" setup>
const { curTabbarRoute, filteredTabbarList } = useTabbar()

const resolveImgPath = (path: string): string => {
  return '/' + path
}
const handleTabbarChange = async ({ value }) => {
  uni.switchTab({
    url: `/${value}`,
  })
}
</script>

<style lang="scss" scoped>
:deep(.wd-tabbar-item__body-icon) {
  font-size: 24px !important;
}
// 文字
:deep(.wd-tabbar-item__body-title) {
  &.is-active {
    @apply text-main;
  }
  &.is-inactive {
    @apply text-primary;
  }
}
// 图标
.icon-active {
  @apply text-main;
}
.icon-inactive {
  @apply text-primary;
}
</style>
